import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";

import {
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";

import {
  putValorCierre,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { InformacionDocumentacion } from "./InformacionDocumentacion";

export const ModalFinalizarPractEnInter = (props) => {
  const dispatch = useDispatch();

  const [valorCierre, setValorCierre] = useState("");

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      idSolicitud: props.idSolicitud,
      valorCierre,
    };
    dispatch(putValorCierre(data, props.idSolicitud, props.close, props.idEstadoSolicitud, props.closeModalAuditar, props.filtros));
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2} style={{ margin: "2rem 0" }} alignItems="center">
            <Grid item xs={12} >
              <TextValidator
                style={{ marginTop: "-3rem", textAlig: "center" }}
                label="Valor Cierre"
                name="valorCierre"
                onChange={(e) => {
                  setValorCierre(e.target.value);
                }}
                // InputLabelProps={{ shrink: true }}  
                value={valorCierre}
                validators={['required', 'isPositive']}
                errorMessages={['El valor es requerido', 'Solo se permiten números']}
              />
            </Grid>
          </Grid>
          <InformacionDocumentacion
            disabled={false}
            setFaltaDocumentacion={null}
            filtros={props.filtros}
            modalFinalizar={true}
          />
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
